<!-- <div class="rtl relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
  
  <div class="rounded-t border-b-2 mb-0 p-6">
    <div class="">
      <h5 class="text-primary text-2xl font-bold mb-4"> درخواست های مالی </h5>
      <h6 class="text-base text-gray-600"> موجودی حساب شما : </h6>
      <h6 class="text-base text-gray-600"> {{wallet}} تومان می باشد. </h6>
      <br>
      <button class="bg-primary text-white rounded pb-2 pt-1 px-3 text-base" (click)="req.open()"> + درخواست جدید </button>
    </div>
  </div>

  <div class="flex flex-wrap pt-6">
    <div class="w-full lg:w-3/12 px-4">
      <div class="relative w-full mb-3">
        <label class="block text-blueGray-600 text-sm font-bold mb-2"> جستجو </label>
        <input type="text" [(ngModel)]="searchInp.title" (keyup)="getRequestsList(0)"
              class="p-3 placeholder-blueGray-300 text-blueGray-600 border-gray-300 rounded text-sm w-full">
      </div>
    </div>
      <div class="w-full lg:w-3/12 px-4">
          <div class="relative w-full mb-3">
            <label class="block uppercase text-blueGray-600 text-sm font-bold mb-2"> نوع درخواست </label>
            <select [(ngModel)]="searchInp.status" (change)="getRequestsList(0)" class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 border-gray-300 rounded text-sm w-full">
              <option value="null">---</option>
              <option value="1"> در انتظار شارژ کیف پول </option>
              <option value="2"> واریز بانک </option>
              <option value="3"> برداشت درصد سایت </option>
              <option value="4"> پرداخت مستقیم </option>
              <option value="5"> برداشت از کیف پول </option>
              <option value="6"> لغو ویزیت </option>
              <option value="7"> واریز پول نقد توسط ادمین </option>
              <option value="8"> خطا در تراکنش </option>
            </select>
          </div>
      </div>
  </div>

  <div class="flex-auto p-4">
      <div class="relative w-full overflow-x-auto rounded-md">
        <table class="w-full bg-transparent border-collapse">
          <thead class="bg-primary text-white">
            <tr>
              <th
                class="align-middle border border-solid p-4 text-base border-l-0 border-r-0 font-semibold" >
                تاریخ ثبت
              </th>
              <th class="align-middle border border-solid p-4 text-base border-l-0 border-r-0 font-semibold"  >
                مقدار
              </th>
              <th class="align-middle border border-solid p-4 text-base border-l-0 border-r-0 font-semibold" >
                زمان تسویه
              </th>
              <th class="align-middle border border-solid p-4 text-base border-l-0 border-r-0 font-semibold" >
                نوع درخواست
              </th>
              <th class="align-middle border border-solid p-4 text-base border-l-0 border-r-0 font-semibold" >
                وضعیت درخواست
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="border-b" *ngFor="let req of requestList">
              <td class="border-t-0 align-middle text-sm p-4">
                 {{(req.creatAt|shamsiDate)}}
              </td>
              <td class="border-t-0 align-middle text-sm p-4">
                  {{req.price}}
              </td>
              <td class="border-t-0 align-middle text-sm p-4" >
              {{req.timeType==1?'متنی':req.timeType==2?'آنی':null}}
              </td>
              
              <td class="border-t-0 align-middle text-sm p-4">
                 {{req.type==1?'در انتظار شارژ کیف پول ':req.type==2?'واریز بانک':req.type==3?'برداشت درصد سایت':req.type==4?'پرداخت مستقیم':
                 req.type==5?'برداشت از کیف پول':req.type==6?'لغو ویزیت':req.type==7?'واریز پول نقد توسط ادمین':req.type==8?'خطا در تراکنش':null}}
              </td>
              <td class="border-t-0 align-middle text-sm p-4">
                 {{req.status==0?'در انتظار تایید':req.status==1?'تایید شده':req.status==3?'درخواست جدید':req.status==2?'رد شده':null}}
              </td>
            </tr>
            
            
          </tbody>
        </table>
        </div>
        <div class="card flex justify-center">      
          <p-paginator
          dir="rtl"
          (onPageChange)="getRequestsList($event.page)"
          [first]="first"
          [rows]="rows"
          [totalRecords]="collectionSize"
          [showCurrentPageReport]="true"
          [showPageLinks]="false"
          [showJumpToPageDropdown]="false"
          currentPageReportTemplate="نمایش {first} تا {last} از {totalRecords} رکورد" />
        </div>
  </div>
</div> -->

<div class="rtl relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0 p-4">
  <p-tabView dir="rtl">
    <p-tabPanel header=" مدیریت مالی ">


      <div class="rounded-t border-b-2 mb-0 ">
        <div class="py-4">
          <h5 class="text-primary text-2xl font-bold mb-4"> کیف پول من </h5>
          <h6 class="text-base text-gray-600"> موجودی شما با کسر پرداخت ویزیت ها: </h6>
          <h6 class="text-base text-gray-600"> {{wallet}} تومان می باشد. </h6>
          <br>
          <!-- <button class="bg-primary text-white font-bold uppercase text-lg px-12 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none "
            (click)="modal.open()"> شارژ کیف پول </button> -->
        </div>
      </div>

      <div class="flex flex-wrap pt-6">
        <h5 class="text-blueGray-700 text-base font-bold py-4"> لیست تراکنشات </h5>
      </div>

      <div class="flex-auto py-4">
        <div class="relative w-full overflow-x-auto rounded-md">
          <table class="w-full bg-transparent border-collapse">
            <thead class="bg-primary text-white">
              <tr>
                <th
                  class="align-middle border border-solid p-4 text-base uppercase border-l-0 border-r-0 font-semibold">
                  تاریخ
                </th>
                <th
                  class="align-middle border border-solid p-4 text-base uppercase border-l-0 border-r-0 font-semibold">
                   از حساب
                </th>
                <th
                  class="align-middle border border-solid p-4 text-base uppercase border-l-0 border-r-0 font-semibold">
                  مبلغ
                </th>
                <th
                  class="align-middle border border-solid p-4 text-base uppercase border-l-0 border-r-0 font-semibold">
                  هزینه
                </th>
                <th
                  class="align-middle border border-solid p-4 text-base uppercase border-l-0 border-r-0 font-semibold">
                  مجموع 
                </th>
                <th
                  class="align-middle border border-solid p-4 text-base uppercase border-l-0 border-r-0 font-semibold">
                  شناسه پرداخت
                </th>
                <th
                  class="align-middle border border-solid p-4 text-base uppercase border-l-0 border-r-0 font-semibold">
                  وضعیت
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="border-b" *ngFor="let trans of transactionList">
                <td class="border-t-0 align-middle text-sm p-4">
                  {{(trans.createAt|shamsiDate)}}
                </td>
                <td class="border-t-0 align-middle text-sm p-4">
                  {{trans.fromName}}
                </td>
                <td class="border-t-0 align-middle text-sm p-4">
                  {{trans.amount}}
                </td>
                <td class="border-t-0 align-middle text-sm p-4">
                  {{trans.fee}}
                </td>
                <td class="border-t-0 align-middle text-sm p-4">
                  {{trans.totalPrice}}
                </td>
                <td class="border-t-0 align-middle text-sm p-4">
                  {{trans.transactionCode}}
                </td>
                <td class="border-t-0 align-middle text-sm p-4">
                  {{trans.type==transactionType.PendingChargeWallet?'در انتظار شارژ کیف پول ':trans.type==transactionType.BankDeposit?'شارژ کیف پول':trans.type==transactionType.FeeSiteDeposit?'واریز سهم سایت':
                      trans.type==transactionType.DirectPayment?'پرداخت مستقیم': trans.type==transactionType.WithDrawFromWallet?'برداشت از کیف پول':trans.type==transactionType.CancelVisit?'لغو توسط کاربر':
                      trans.type==transactionType.AdminCashOut?'پرداخت توسط ادمین':trans.type==transactionType.TransactionLogError?'خطا در ثبت تراکنش':trans.type==transactionType.IncomeDoctorDeposit?'واریز سهم پزشک':
                      trans.type==9?'لغو توسط پزشک':null}}
                </td>
              </tr>

            </tbody>
          </table>
        </div>
        <div class="card flex justify-center">      
          <p-paginator
          dir="rtl"
          (onPageChange)="getFinanceTransactions($event.page)"
          [first]="first1"
          [rows]="rows1"
          [totalRecords]="collectionSize1"
          [showCurrentPageReport]="true"
          [showPageLinks]="false"
          [showJumpToPageDropdown]="false"
          currentPageReportTemplate="نمایش {first} تا {last} از {totalRecords} رکورد" />
        </div>
      </div>

    </p-tabPanel>
    <p-tabPanel header=" درخواست ها ">
      
      <div class="rtl relative flex flex-col min-w-0 break-words w-full mb-6 border-0">
        <div class="rounded-t border-b-2 mb-0 ">
          <div class="py-4 mb-6">
            
            <div class="md:w-8/12 w-full"> 
              <label class="block text-blueGray-600 text-sm font-bold mb-2">
                 مقدار
              </label>
              <input type="number" [(ngModel)]="cashReqInp.price"
                  class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm md:w-6/12 w-full" />
              <button class="bg-primary text-white font-bold uppercase text-lg my-2 m-16 px-6 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none "
                (click)="sendRequest()"> ثبت درخواست</button>
            </div>
            
          </div>
        </div>
    
        <div class="flex flex-wrap pt-6">
            <div class="w-full lg:w-3/12 ">
                <div class="relative w-full mb-3">
                  <label class="block uppercase text-blueGray-600 text-sm font-bold mb-2"> نوع درخواست </label>
                  <select class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 border-gray-300 rounded text-sm w-full">
                    <option value="null">---</option>
                    <option value="1"> در انتظار شارژ کیف پول </option>
                    <option value="2"> واریز بانک </option>
                    <!-- <option value="3"> برداشت درصد سایت </option> -->
                    <option value="4"> پرداخت مستقیم </option>
                    <option value="5"> برداشت از کیف پول </option>
                    <option value="6"> لغو ویزیت </option>
                    <option value="7"> واریز پول نقد توسط ادمین </option>
                    <!-- <option value="8"> خطا در تراکنش </option> -->
                  </select>
                </div>
            </div>
            <!-- <div class="w-full lg:w-3/12 px-4">
                <div class="relative w-full mb-3"><label htmlfor="grid-password"
                        class="block uppercase text-blueGray-600 text-sm font-bold mb-2"> تاریخ </label><input type="text"
                        class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 border-gray-300 rounded text-sm focus:outline-none w-full">
                </div>
            </div> -->
        </div>
    
        <div class="flex-auto">
            <div class="relative w-full overflow-x-auto rounded-md">
              <table class="w-full bg-transparent border-collapse">
                <thead class="bg-primary text-white">
                  <tr>
                    <th
                      class="align-middle border border-solid p-4 text-base border-l-0 border-r-0 font-semibold" >
                      تاریخ ثبت
                    </th>
                    <th class="align-middle border border-solid p-4 text-base border-l-0 border-r-0 font-semibold"  >
                      مقدار
                    </th>
                    <th class="align-middle border border-solid p-4 text-base border-l-0 border-r-0 font-semibold" >
                      زمان تسویه
                    </th>
                    <th class="align-middle border border-solid p-4 text-base border-l-0 border-r-0 font-semibold" >
                      نوع درخواست
                    </th>
                    <th class="align-middle border border-solid p-4 text-base border-l-0 border-r-0 font-semibold" >
                      وضعیت درخواست
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="border-b" *ngFor="let req of requestList">
                    <td class="border-t-0 align-middle text-sm p-4">
                       {{(req.creatAt|shamsiDate)}}
                    </td>
                    <td class="border-t-0 align-middle text-sm p-4">
                        {{req.price}}
                    </td>
                    <td class="border-t-0 align-middle text-sm p-4" >
                    {{req.timeType==1?'متنی':req.timeType==2?'آنی':null}}
                    </td>
                    
                    <td class="border-t-0 align-middle text-sm p-4">
                      {{req.type==transactionType.PendingChargeWallet?'در انتظار شارژ کیف پول ':req.type==transactionType.BankDeposit?'واریز بانک':req.type==transactionType.FeeSiteDeposit?'برداشت درصد سایت':
                      req.type==transactionType.DirectPayment?'پرداخت مستقیم': req.type==transactionType.WithDrawFromWallet?'برداشت از کیف پول':req.type==transactionType.CancelVisit?'لغو ویزیت':
                      req.type==transactionType.AdminCashOut?'واریز پول نقد توسط ادمین':req.type==transactionType.TransactionLogError?'خطا در تراکنش':req.type==transactionType.IncomeDoctorDeposit?'واریز ویزیت':null}}
                    </td>
                    <td class="border-t-0 align-middle text-sm p-4">
                       {{req.status==0?'در انتظار تایید':req.status==1?'تایید شده':req.status==3?'درخواست جدید':req.status==2?'رد شده':null}}
                    </td>
                  </tr>
                </tbody>
              </table>
              </div>
              <div class="card flex justify-center">      
                <p-paginator
                dir="rtl"
                (onPageChange)="getRequestsList($event.page)"
                [first]="first"
                [rows]="rows"
                [totalRecords]="collectionSize"
                [showCurrentPageReport]="true"
                [showPageLinks]="false"
                [showJumpToPageDropdown]="false"
                currentPageReportTemplate="نمایش {first} تا {last} از {totalRecords} رکورد" />
              </div>
        </div>
    </div>
        

    </p-tabPanel>
  </p-tabView>
</div>

<p-toast dir="rtl"></p-toast>

<!-- MODAL SECTION -->

<app-modal #req>
  <!--header-->
  <div class="flex items-start justify-between p-2 border-b border-solid border-blueGray-200 rounded-t">
    <h3 class="text-xl font-semibold" style="margin-inline-end: 16rem;">
      ثبت درخواست
    </h3>
    <button
      class="p-1 bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
      (click)="req.close()">
      <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
        ×
      </span>
    </button>
  </div>
  <!--body-->
  <div class="relative py-2 flex-auto">
    <div class="flex flex-wrap text-right">


      <div class="w-full p-2">
          <div class="relative w-full mb-3">
              <label class="block text-blueGray-600 text-sm font-bold mb-2">
                  زمان تسویه
              </label>
              <select  [(ngModel)]="cashReqInp.timeType"
                  class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm border-gray-300 w-full" >
                    <option [value]="2"> آنی </option>
              </select>
          </div>
      </div>
      <div class="w-full p-2">
          <div class="relative w-full mb-3">
              <label class="block text-blueGray-600 text-sm font-bold mb-2">
                   مقدار
              </label>
              <input type="number" [(ngModel)]="cashReqInp.price"
                  class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
          </div>
      </div>
  </div>
  </div>
  <!--footer-->
  <div class="flex items-center justify-between py-2 border-t border-solid border-blueGray-200 rounded-b">
    <button
      class="text-red-500 border-red-500 background-transparent font-bold px-6 py-2 rounded text-sm my-2 ease-linear transition-all duration-150"
      type="button" (click)="req.close();">
      انصراف
    </button>
    <button
      class="bg-primary text-white active:bg-red-500 font-bold text-sm px-6 py-2 rounded shadow hover:shadow-lg my-2 ease-linear transition-all duration-150"
      type="button" (click)="sendRequest()">
      تایید
    </button>
  </div>
</app-modal>